import { render, staticRenderFns } from "./catalog-title.vue?vue&type=template&id=a2b2c158&"
import script from "./catalog-title.vue?vue&type=script&lang=js&"
export * from "./catalog-title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports